import "../../FhDialog.css";
import { ref, watch, nextTick, useSlots, computed, onUnmounted, openBlock, createElementBlock, Fragment, createBlock, resolveDynamicComponent, createCommentVNode, mergeProps, createElementVNode, normalizeClass, withCtx, renderSlot, unref, createTextVNode } from "vue";
import FhIconButton from "../Buttons/FhIconButton/FhIconButton.mjs";
import FhTitle from "../FhTitle/FhTitle.mjs";
import FhVisuallyHidden from "../FhVisuallyHidden/FhVisuallyHidden.mjs";
import close from "../../icons/close.mjs";
import { generateUniqueId } from "../utils.mjs";
import { SIZES_ENUMS } from "./constants.mjs";
import { useSlotValidation } from "../composables/useSlotValidation.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = ["aria-labelledby"];
const _hoisted_2 = {
  key: 0,
  class: "fh-dialog-header"
};
const _hoisted_3 = {
  key: 1,
  class: "fh-dialog-content"
};
const _hoisted_4 = {
  key: 2,
  class: "fh-dialog-footer"
};
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhDialog",
  props: {
    size: {
      type: String,
      default: SIZES_ENUMS.MD,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    },
    dismissible: {
      type: Boolean,
      default: true
    },
    inertTarget: {
      type: [String, Array],
      default: "body"
    }
  },
  emits: ["update:isOpen"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const dialogWrapper = ref(null);
    const dialogContent = ref(null);
    const invoker = ref(null);
    const isOpen = ref(false);
    const titleId = `fh-dialog-${generateUniqueId()}`;
    const collectInertTargets = () => {
      return (Array.isArray(props.inertTarget) ? props.inertTarget : [props.inertTarget]).map((selector) => {
        if (!selector) {
          return document.body;
        }
        return document.querySelector(selector);
      }).filter(Boolean);
    };
    const setInertAndScroll = (shouldLock) => {
      const inertTargets = collectInertTargets();
      const isAnyDialogOpen = document.querySelector(".fh-dialog-wrapper[open]") !== null;
      inertTargets.forEach((element) => {
        const el = element;
        if (shouldLock) {
          el.setAttribute("inert", "");
          el.style.overflow = "hidden";
        } else if (!isAnyDialogOpen) {
          el.removeAttribute("inert");
          el.style.overflow = "";
        }
      });
    };
    const open = () => {
      isOpen.value = true;
    };
    const close$1 = async () => {
      var _a;
      isOpen.value = false;
      await nextTick();
      if (invoker.value) {
        const invokerEl = invoker.value.$el || invoker.value;
        (_a = invokerEl.focus) == null ? void 0 : _a.call(invokerEl);
      }
    };
    watch(isOpen, async (newVal) => {
      var _a, _b;
      if (newVal) {
        await nextTick();
        (_a = dialogWrapper.value) == null ? void 0 : _a.showModal();
        setInertAndScroll(true);
        emit("update:isOpen", true);
      } else {
        (_b = dialogWrapper.value) == null ? void 0 : _b.close();
        setInertAndScroll(false);
        emit("update:isOpen", false);
      }
    });
    const handleKeydown = (event) => {
      if (event.key === "Escape") {
        if (props.dismissible) {
          close$1();
        } else {
          event.preventDefault();
        }
      }
    };
    const handleClickOutside = (event) => {
      var _a;
      if (isOpen.value && props.dismissible && !((_a = event == null ? void 0 : event.composedPath()) == null ? void 0 : _a.includes(dialogContent.value))) {
        close$1();
      }
    };
    const slots = useSlots();
    const computedDefaultSlotVNode = computed(() => {
      var _a, _b;
      return {
        ...(_b = (_a = slots.default) == null ? void 0 : _a.call(slots)) == null ? void 0 : _b[0]
      };
    });
    const computedDialogClasses = computed(() => [
      "fh-dialog",
      `fh-dialog--${props.size}`
    ]);
    const computedLabelledby = computed(() => slots.title ? titleId : null);
    useSlotValidation("FhDialog", slots, [["title", "hiddenTitle"]]);
    onUnmounted(() => {
      setInertAndScroll(false);
    });
    __expose({
      isOpen,
      open,
      close: close$1
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        _ctx.$slots.default ? (openBlock(), createBlock(resolveDynamicComponent(computedDefaultSlotVNode.value), {
          key: 0,
          selected: isOpen.value,
          onClick: open,
          ref_key: "invoker",
          ref: invoker
        }, null, 8, ["selected"])) : createCommentVNode("", true),
        createCommentVNode("", true),
        isOpen.value ? (openBlock(), createElementBlock("dialog", mergeProps({
          key: 2,
          class: "fh-dialog-wrapper",
          "aria-labelledby": computedLabelledby.value,
          "aria-modal": "true",
          ref_key: "dialogWrapper",
          ref: dialogWrapper,
          onKeydown: handleKeydown,
          onClick: handleClickOutside
        }, _ctx.$attrs), [
          createElementVNode("div", {
            class: normalizeClass(["fh-dialog", computedDialogClasses.value]),
            ref_key: "dialogContent",
            ref: dialogContent
          }, [
            _ctx.$slots.header || _ctx.$slots.title || _ctx.$slots.hiddenTitle || props.dismissible ? (openBlock(), createElementBlock("div", _hoisted_2, [
              _ctx.$slots.title ? (openBlock(), createBlock(FhTitle, {
                key: 0,
                class: "fh-dialog-title",
                variant: "display-lg",
                tag: "h2",
                id: titleId
              }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "title", {}, void 0, true)
                ]),
                _: 3
              })) : _ctx.$slots.hiddenTitle ? (openBlock(), createBlock(FhVisuallyHidden, { key: 1 }, {
                default: withCtx(() => [
                  renderSlot(_ctx.$slots, "hiddenTitle", {}, void 0, true)
                ]),
                _: 3
              })) : createCommentVNode("", true),
              renderSlot(_ctx.$slots, "header", {}, void 0, true),
              props.dismissible ? (openBlock(), createBlock(FhIconButton, {
                key: 2,
                class: "fh-dialog-close",
                icon: unref(close),
                variant: "plain",
                size: "sm",
                onClick: close$1
              }, {
                default: withCtx(() => [
                  createTextVNode(" Close ")
                ]),
                _: 1
              }, 8, ["icon"])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            _ctx.$slots.content ? (openBlock(), createElementBlock("div", _hoisted_3, [
              renderSlot(_ctx.$slots, "content", {}, void 0, true)
            ])) : createCommentVNode("", true),
            _ctx.$slots.footer ? (openBlock(), createElementBlock("div", _hoisted_4, [
              renderSlot(_ctx.$slots, "footer", {}, void 0, true)
            ])) : createCommentVNode("", true)
          ], 2)
        ], 16, _hoisted_1)) : createCommentVNode("", true)
      ], 64);
    };
  }
});
const FhDialog = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-3145bbc9"]]);
export {
  FhDialog as default
};
//# sourceMappingURL=FhDialog.mjs.map
